export default function elementInViewport(el, d) {
  if (el) {
    const elemTop = el.offsetTop;
    const elemHeight = window.innerHeight;
    const elemBottom = elemTop + elemHeight;
    const delta = d || 0;

    const holderTop = window.scrollY || document.documentElement.scrollTop;
    const holderBottom = (elemHeight + holderTop);

    let isVisible = false;

    if (elemTop <= holderTop - delta) {
      isVisible = !(holderTop - elemTop > elemHeight + delta);
    } else {
      isVisible = !(elemBottom - holderBottom > elemHeight - delta);
    }

    return isVisible;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/helpers/viewport.js